export default {"src":"/_next/static/media/for-publishers-1.4c45bdfa.svg","height":919,"width":1440};